export enum USER_ROLES_TYPE {
    INSTALLATION = 'Installation',
    BIOMEDICAL = 'Biomedical',
    SHS_EMPLOYEE = 'ShsEmployee',
    SERVICE_PARTNER = 'ServicePartner',
    UNKNOWN = '',
}

const userRoleTypeMap: Record<string, USER_ROLES_TYPE> = {
    ACL15: USER_ROLES_TYPE.INSTALLATION,
    ACL12: USER_ROLES_TYPE.BIOMEDICAL,
    ACL20: USER_ROLES_TYPE.BIOMEDICAL,
    ACL40: USER_ROLES_TYPE.SHS_EMPLOYEE,
    ACL45: USER_ROLES_TYPE.SHS_EMPLOYEE,
    ACL50: USER_ROLES_TYPE.SHS_EMPLOYEE,
    ACL60: USER_ROLES_TYPE.SHS_EMPLOYEE,
    ACL30: USER_ROLES_TYPE.SERVICE_PARTNER,
    ACL35: USER_ROLES_TYPE.SERVICE_PARTNER,
};

export function getUserRoleType(userId: string): USER_ROLES_TYPE {
    return userRoleTypeMap[userId] || USER_ROLES_TYPE.UNKNOWN;
}
